(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredient-carousel"] && !Shopify.designMode) return;
  try {
    
  class IngredientCarousel {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-carousel-track]');
      this.cards = Array.from(section.querySelectorAll('.ingredient-card'));
      this.prevBtn = section.querySelector('[data-nav="prev"]');
      this.nextBtn = section.querySelector('[data-nav="next"]');
      this.dotsContainer = section.querySelector('[data-dots]');
      this.dots = Array.from(section.querySelectorAll('[data-dot]'));
      this.addToCartBtn = section.querySelector('[data-add-to-cart]');

      this.currentIndex = 0;
      this.cardsPerView = this.getCardsPerView();
      this.maxIndex = Math.max(0, Math.ceil(this.cards.length / this.cardsPerView) - 1);

      this.init();
    }

    init() {
      // Setup event listeners
      this.setupEventListeners();

      // Update navigation state
      this.updateNavigation();

      // Update dots visibility
      this.updateDotsVisibility();
    }

    setupEventListeners() {
      // Navigation arrows
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Dots
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.dot);
          this.goToSlide(index);
        });
      });

      // Card toggles
      this.cards.forEach(card => {
        const toggleBtn = card.querySelector('[data-toggle]');
        if (toggleBtn) {
          toggleBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            card.classList.toggle('expanded');
          });
        }
      });

      // Add to cart
      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener('click', () => this.addToCart());
      }

      // Window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.cardsPerView = this.getCardsPerView();
          this.maxIndex = Math.max(0, Math.ceil(this.cards.length / this.cardsPerView) - 1);
          this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
          this.updateCarousel();
          this.updateDotsVisibility();
        }, 200);
      });
    }

    getCardsPerView() {
      const width = window.innerWidth;
      if (width <= 749) return 1;
      if (width <= 1024) return 2;
      return 4;
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateCarousel();
      }
    }

    next() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
        this.updateCarousel();
      }
    }

    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
      this.updateCarousel();
    }

    updateCarousel() {
      if (!this.track || this.cards.length === 0) return;

      const cardWidth = this.cards[0].offsetWidth;
      const gap = 11;
      const offset = -(this.currentIndex * this.cardsPerView * (cardWidth + gap));
      
      this.track.style.transform = `translateX(${offset}px)`;
      
      this.updateNavigation();
      this.updateDots();
    }

    updateNavigation() {
      if (this.prevBtn) {
        this.prevBtn.style.opacity = this.currentIndex === 0 ? '0.3' : '1';
        this.prevBtn.style.pointerEvents = this.currentIndex === 0 ? 'none' : 'auto';
      }
      
      if (this.nextBtn) {
        this.nextBtn.style.opacity = this.currentIndex === this.maxIndex ? '0.3' : '1';
        this.nextBtn.style.pointerEvents = this.currentIndex === this.maxIndex ? 'none' : 'auto';
      }
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentIndex);
      });
    }

    updateDotsVisibility() {
      // Calculate how many dot groups we need
      const totalDots = Math.ceil(this.cards.length / this.cardsPerView);
      
      // Hide dots that exceed the total needed
      this.dots.forEach((dot, index) => {
        dot.style.display = index < totalDots ? 'block' : 'none';
      });
    }

    async addToCart() {
      if (!this.addToCartBtn) return;
      
      const variantId = this.addToCartBtn.dataset.addToCart;
      const originalText = this.addToCartBtn.querySelector('span').textContent;
      
      try {
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.querySelector('span').textContent = 'ADDING...';
        
        const formData = {
          'items': [{
            'id': variantId,
            'quantity': 1
          }]
        };
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        
        if (response.ok) {
          this.addToCartBtn.querySelector('span').textContent = 'ADDED!';
          
          // Dispatch event for cart update
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
          // Reset button after 2 seconds
          setTimeout(() => {
            this.addToCartBtn.querySelector('span').textContent = originalText;
            this.addToCartBtn.disabled = false;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.addToCartBtn.querySelector('span').textContent = 'ERROR';
        setTimeout(() => {
          this.addToCartBtn.querySelector('span').textContent = originalText;
          this.addToCartBtn.disabled = false;
        }, 2000);
      }
    }
  }

  // Initialize carousel
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.ingredient-carousel');
    sections.forEach(section => {
      new IngredientCarousel(section);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
